import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  RouterNav,
  RouterList,
  RouterItem,
  TabIcon,
  TabText,
} from "./styles/subnav-styles";

const SubNavigation = () => (
  <RouterNav id="tab-nav" className="animated fadeIn">
    <RouterList>
      <RouterItem>
        <NavLink to="/" exact activeClassName="active">
          <TabIcon>
            <FontAwesomeIcon icon={faCalendarAlt} />
          </TabIcon>
          <TabText>Pay Annually</TabText>
        </NavLink>
      </RouterItem>
      {/* TODO_remove_stripe: This goes when we remove the last of the Stripe integration */}
      {/*<RouterItem>*/}
      {/*  <NavLink to="/monthly" exact>*/}
      {/*    <TabIcon>*/}
      {/*      <FontAwesomeIcon icon={faCalendarAlt} />*/}
      {/*    </TabIcon>*/}
      {/*    <TabText>Pay Monthly</TabText>*/}
      {/*  </NavLink>*/}
      {/*</RouterItem>*/}
    </RouterList>
  </RouterNav>
);

export default SubNavigation;
